// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-loader{position:fixed;top:0;left:0;width:100%;height:100%;background:#ffffffeb;z-index:99999;display:none}.base-loader.loading{display:block}.base-loader img,.base-loader svg{position:absolute;top:50%;left:50%;width:120px;height:120px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
